import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { ChannelIcon } from '../../ChannelIcon';
export const ChannelsSubList = ({ data, filterChannels }) => {
    var _a;
    const { t } = useAlertUiTranslation();
    const upSmScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const channels = (_a = data.channels) === null || _a === void 0 ? void 0 : _a.filter((channel) => filterChannels.includes(channel));
    if (channels && channels.length > 0) {
        return (React.createElement(Box, { sx: { display: 'flex', gap: 2, pl: 2 } }, channels.map((channel) => (React.createElement(Typography, { key: channel, variant: 'body2', color: themeColors.text.subtle },
            React.createElement(ChannelIcon, { channel: channel, fontSize: 'small', sx: { verticalAlign: 'middle', mr: 1 } }),
            upSmScreen && t(`common.channels.${channel}`))))));
    }
    else {
        return null;
    }
};
